module.exports = __webpack_public_path__ + "media/unipod/eight_step1-186750b5.jpg";